import { PageLayout } from '@bpm-web-app/components';
import { ArtistDetail } from '@bpm-web-app/components/pages';

const ArtistDetailPage = () => {
    return (
        <PageLayout>
            <ArtistDetail />
        </PageLayout>
    );
};

export default ArtistDetailPage;
